<template>
  <div>
    <div
      class="flex-row"
      style="
        background: #7832b0;
        height: 80px;
        justify-content: space-between;
        padding: 0 30px;
        position: fixed;
        right: 0;
        left: 0;
        top: 0;
        box-shadow: 0 5px 5px -5px rgba(0, 0, 0, 0.6);
        z-index: 999;
      "
    >
      <div>
        <img src="~img/home/head-logo.png" style="width: 150px; height: 17px" />
      </div>
      <van-icon @click="show = true" name="wap-nav" color="#ffffff" size="25" />
    </div>
    <van-popup v-model="show" position="left" :style="{ height: '100%' }">
      <div style="text-align: left; padding: 30px; color: #7832b0; font-weight: bold">
        <img src="~img/home/head-logo1.png" style="width: 160px; height: 21px" />
        <div style="margin-top: 50px" @click="$router.push('/loan')">Applying for a loan</div>
        <div style="margin-top: 30px">
          <a href="https://club.adelantos.com.ar">Advance Club</a>
        </div>
        <div style="margin-top: 30px">
          <a href="https://blog.adelantos.com.ar">Blog</a>
        </div>
        <div style="margin-top: 30px">
          <a href="https://customeradelantos.zohodesk.com/portal/es/kb"> Help Center </a>
        </div>
        <div style="margin-top: 30px" @click="$router.push('/center')">My Account</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false
    }
  },
  async created() {},
  methods: {}
}
</script>

<style scoped lang="less">
.font-w {
  font-weight: bold;
  line-height: 40px;
}
</style>
